<template>
  <div>
    <!-- <teleport :to="body"> -->
    <div class="overlay">
      <div class="overlay-right">
        <div class="overlay-right-header">
          <div style="font-weight: bold">活动详情</div>
          <div @click="onClose" style="cursor: pointer">
            <BaseSvg
              style="width: 20px; height: 20px"
              iconClass="close"
            ></BaseSvg>
          </div>
        </div>
        <div class="overlay-right-main">
          <div class="overlay-right-main__reuqire">
            <div class="overlay-right-main__reuqire-item">
              <div>文件夹名称：</div>
              <div>{{ detailInfo.folderName }}</div>
            </div>
            <div class="overlay-right-main__reuqire-item">
              <div>上传附件数：</div>
              <div>{{ detailInfo.fileCount }}</div>
            </div>
            <div class="overlay-right-main__reuqire-item">
              <div>项目参与人：</div>
              <div>{{ detailInfo.peopleNum }}</div>
            </div>
          </div>

          <BaseTable
            style="margin-bottom: 16px"
            :columns="columns"
            :data="detailInfo.fileList"
          ></BaseTable>
        </div>
        <div class="overlay-right-footer">
          <div>
            <!-- <BaseButton @click="onAudit(2)" plain>通过</BaseButton>
            <BaseButton type="default" @click="onAudit(3)" plain>
              不通过
            </BaseButton> -->
            <BaseButton @click="onClose()" type="default">关闭</BaseButton>
          </div>
        </div>
      </div>
      <div class="overlay-left">
        <BaseImageViewer
          v-if="imgViewerShow"
          @switch="onChangeActive"
          :infinite="true"
          :preview-src-list="picList"
          :initial-index="showIndex"
          :hide-close="true"
        ></BaseImageViewer>
      </div>
    </div>
    <!-- </teleport> -->
  </div>
</template>
<script lang="tsx" setup>
import { defineProps, withDefaults, watch, ref, nextTick } from 'vue';
import { BaseSvg } from '@/components/base/base-svg/index';
// import { useTaskAudit } from '../hooks/useTaskAudit';
import {
  BaseImageViewer,
  BaseTable,
  useTableColumn,
  BaseTableProps,
  BaseButton
} from 'xrk-components';
import { formatter } from '@/utils/';
import { download } from 'xrk-tools';
const props = withDefaults(
  defineProps<{
    remove: any;
    detailInfo: any;
  }>(),
  {}
);

const columns = ref<BaseTableProps['columns']>([
  useTableColumn({
    label: '文件名称',
    prop: 'fileName'
  }),
  useTableColumn({
    label: '文件上传时间',
    prop: 'createAt',
    formatter: ({ cellValue }) => formatter.date(cellValue)
  }),
  useTableColumn({
    label: '操作',
    prop: 'handle',
    render: ({ row }) => {
      return (
        <BaseButton
          type="text"
          click={async () => {
            download.downloadFile(row.fileUrl, {
              fileName: row.fileName
            });
          }}
        >
          下载
        </BaseButton>
      );
    }
  })
]);

// const body = document.body;

const imgViewerShow = ref(true);
const showIndex = ref(0);
// const emits = defineEmits(['auditOver']);

const onChangeActive = index => {
  showIndex.value = index;
};
// const onAudit = async status => {
//   useTaskAudit({
//     auditStatus: status,
//     projectId: props.projectId,
//     queryParams: {
//       sceneType: props.projectType,
//       taskRecordId: [props.id]
//     },
//     auditOver() {
//       emits('auditOver');
//     }
//   });
// };

const picList = ref([]); //图片列表

const init = async () => {
  const imageTypeReg = new RegExp(/\.bmp|\.jpg|\.png|\.gif|\.jpeg/, 'i');
  props.detailInfo.fileList.forEach(item => {
    // item.url 后缀为图片则push
    if (imageTypeReg.test(item.fileUrl)) {
      picList.value.push(item.fileUrl);
    }
  });
  if (!picList.value.length) {
    imgViewerShow.value = false;
  }
};
init();

watch(
  () => showIndex.value,
  () => {
    imgViewerShow.value = false;
    nextTick(() => {
      imgViewerShow.value = true;
    });
  }
);

const onClose = () => {
  props.remove();
};
</script>
<style lang="scss" scoped>
::v-deep {
  .xrk-image-viewer__mask {
    opacity: 0;
  }
}
.overlay {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 99;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  overflow: auto;
  &-right {
    z-index: 3000;
    position: absolute;
    box-sizing: border-box;
    background-color: #fff;
    display: flex;
    flex-direction: column;
    box-shadow: 0px 16px 48px 16px rgba(0, 0, 0, 0.08),
      0px 12px 32px rgba(0, 0, 0, 0.12), 0px 8px 16px -8px rgba(0, 0, 0, 0.16);
    overflow: hidden;
    width: 25%;
    height: 100%;
    right: 0;
    animation: slip_in 0.3s;
    &-header {
      -webkit-box-align: center;
      -ms-flex-align: center;
      align-items: center;
      color: #72767b;
      display: flex;
      justify-content: space-between;
      padding: 20px 20px 22px 20px;
      border-bottom: 1px solid #c1c1c1;
    }
    &-main {
      height: calc(100vh - 160px);
      position: relative;
      overflow: auto;
      box-sizing: border-box;
      padding: 20px;
      &__reuqire {
        padding-bottom: 24px;
        &-item {
          display: flex;
          align-items: center;
          margin-bottom: 5px;
          justify-content: space-between;
        }
      }
      &__info {
        margin-top: 24px;
      }
    }
    &-footer {
      text-align: right;
      height: 80px;
      background: #fff;
      border-top: 1px solid #c1c1c1;
      width: 100%;
      position: absolute;
      bottom: 0;
      padding: 25px 50px;
    }
  }
  &-left {
    width: 75%;
    height: 100%;
    position: absolute;
    overflow: hidden;
    left: 0;
  }
}

/*右侧滑入*/
@keyframes slip_in {
  from {
    transform: translateX(100%);
  }
  to {
    transform: translateX(0);
  }
}
</style>
